// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { useSession } from '../session-context.js';
import '../styles/session-expired-modal.css';

/**
 * F17.1 — full-screen modal shown when the session is expired
 * (idle-timeout, server 401, or peer-tab logout broadcast). Blocks the
 * UI behind the overlay and routes the user back to the sign-in page
 * via `logout()`, which clears local state and transitions the session
 * status back to `unauthenticated`.
 */
export function SessionExpiredModal() {
  const { status, logout } = useSession();
  if (status !== 'expired') return null;

  function handleSignIn() {
    logout();
    if (typeof window !== 'undefined' && window.location.pathname !== '/') {
      window.location.assign('/');
    }
  }

  return (
    <div
      class="session-expired-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
    >
      <div class="session-expired-card">
        <h2 id="session-expired-title">Session expired</h2>
        <p>
          You've been inactive for a while, so we signed you out to keep
          your account safe.
        </p>
        <button
          class="btn btn-primary session-expired-cta"
          onClick={handleSignIn}
        >
          Sign in again
        </button>
      </div>
    </div>
  );
}
